import React from 'react';
import { Helmet } from 'react-helmet';
import { CURRENT_COUNTRY_CODE, CURRENT_SITE_URL } from 'config/env';

const RenderSEO = props => {
  let {
    metaTags: { metaTitle, metaDescription, metaKeywords },
    currentRouteName,
  } = props;
  const siteUrl = CURRENT_SITE_URL;
  const currentUrl = currentRouteName
    ? `${siteUrl}${currentRouteName}`
    : siteUrl;

  return (
    <div className="application">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaTitle}</title>
        <link rel="canonical" href={currentUrl} />
        <meta name="description" content={metaDescription} />
        <meta
          name="facebook-domain-verification"
          content="4aiwpvh9d6tiszldivpeuo1yttokao"
        />
        <meta name="keywords" content={metaKeywords} />
        {CURRENT_COUNTRY_CODE === '+91' ? (
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-N5K46X8');
          `}
          </script>
        ) : (
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-WRXD86RD');`}
          </script>
        )}
        {CURRENT_COUNTRY_CODE === '+91' ? (
          <body>
            {`
            <noscript>
              <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N5K46X8"
                height="0" width="0" style="display:none;visibility:hidden">
              </iframe>
            </noscript>
          `}
          </body>
        ) : (
          <body>
            {`
            <noscript>
              <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WRXD86RD"
                height="0" width="0" style="display:none;visibility:hidden">
              </iframe>
            </noscript>
          `}
          </body>
        )}
      </Helmet>
    </div>
  );
};

export default RenderSEO;
